import React from "react";
import Header from "../../components/skinefit/Header";
import Img1 from "../../assets/images/skinefit/about/1.png";
import Img2 from "../../assets/images/skinefit/about/2.png";
import Img3 from "../../assets/images/skinefit/about/3.png";
import Img4 from "../../assets/images/skinefit/about/4.png";
import Img5 from "../../assets/images/skinefit/about/5.png";
import Img6 from "../../assets/images/skinefit/about/6.png";
import Img7 from "../../assets/images/skinefit/about/7.png";
import Img8 from "../../assets/images/skinefit/about/8.png";
import Img9 from "../../assets/images/skinefit/about/9.png";
import Img10 from "../../assets/images/skinefit/about/10.png";
import Img11 from "../../assets/images/skinefit/about/11.png";
const About = () => {
  return (
    <div className="overflow-x-hidden h-full">
      <Header />
      <div className="w-full bg-[#f5eae6] flex flex-col items-center justify-center">
        <img src={Img1} alt="" />
        <img src={Img2} alt="" />
        <img src={Img3} alt="" />
        <img src={Img4} alt="" />
        <img src={Img5} alt="" />
        <img src={Img6} alt="" />
        <img src={Img7} alt="" />
        <img src={Img8} alt="" />
        <img src={Img9} alt="" />
        <img src={Img10} alt="" />
        <img src={Img11} alt="" />
      </div>
    </div>
  );
};

export default About;
